import { render, staticRenderFns } from "./order_flow.vue?vue&type=template&id=2677805c"
import script from "./order_flow.vue?vue&type=script&lang=js"
export * from "./order_flow.vue?vue&type=script&lang=js"
import style0 from "./order_flow.vue?vue&type=style&index=0&id=2677805c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports